import { styles } from './template.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePackagePanel = document.createElement('template');

templatePackagePanel.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>
      <div class='form-wrapper'>
        <section id='package-general-form-wrapper'></section>

        <gz-download-type-form></gz-download-type-form>

        <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='general-details-subtitle'></gz-title>
        <gz-package-general-form></gz-package-general-form>

        <gz-package-modules-form></gz-package-modules-form>

        <gz-package-scan-modes-form></gz-package-scan-modes-form>

        <gz-package-security-server-assignment-grid context='create'></gz-package-security-server-assignment-grid>

        <gz-package-miscellaneous-form context='create'></gz-package-miscellaneous-form>

        <gz-package-settings-form context='create'></gz-package-settings-form>

        <section id='package-deployer-form-wrapper'></section>
        <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='deployer-form-subtitle'></gz-title>

        <gz-package-deployer-form context='create'></gz-package-deployer-form>

        <gz-package-use-proxy-form context='create'></gz-package-use-proxy-form>

        <gz-info-box id='remove-competitor-info' class='info-box-style' severity='warning'></gz-info-box>

      </div>
      <div class='bottom-buttons'>
        <gz-button id='save-button' disabled></gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
`;
